const measure = (el) => {
  const pV = el.style.visibility
  const pP = el.style.position

  el.style.visibility = 'hidden'
  el.style.position = 'absolute'

  document.body.appendChild(el)

  const result = el.offsetWidth

  el.parentNode.removeChild(el)
  el.style.visibility = pV
  el.style.position = pP

  return result
}
const createElement = (classList, content) => {
  const el = document.createElement('div')

  el.setAttribute('class', classList)

  if (content) {
    el.innerText = content
  }

  return el
}
const createBox = value => {
  const box = createElement('tooltipster-box')
  const content = createElement('tooltipster-content', value)

  box.appendChild(content)

  return box
}
const createArrow = () => {
  const arrowWrap = createElement('tooltipster-arrow')
  const arrow = createElement('tooltipster-arrow-uncropped')
  const border = createElement('tooltipster-arrow-border')
  const background = createElement('tooltipster-arrow-background')

  arrow.appendChild(border)
  arrow.appendChild(background)

  arrowWrap.appendChild(arrow)

  return arrowWrap
}
const createTooltipster = ({ text, mode, alwaysVisible }, id) => {
  const toolTipClass = `tooltipster-base ${mode ? `tooltipster${mode}` : ''} ${alwaysVisible ? '_always-visible' : '_hidden-mobile'}`
  const toolTip = createElement(toolTipClass)

  toolTip.appendChild(createBox(text))
  toolTip.appendChild(createArrow())

  toolTip.setAttribute('id', `tooltip-${id}`)

  return toolTip
}

const enterFn = function (el, { value }, id) {
  return function enterCurriedFunc (ev) {
    const tooltip = createTooltipster(value, id)
    const tooltipDimension = ev.target.getBoundingClientRect()

    tooltip.style['z-index'] = 99999
    tooltip.style.left = `${tooltipDimension.left - (measure(tooltip) / 2 -  tooltipDimension.width / 2)}px`
    tooltip.style.top = `${tooltipDimension.top + window.scrollY - 17}px`

    document.body.appendChild(tooltip)

    // TODO убрать setTimeout
    setTimeout(() => {
      tooltip.classList.add('tooltipster-show')
    }, 0)
  }
}
const leaveFn = function (id) {
  return function leaveCurriedFunc () {
    try {
      const elemToRemove = document.getElementById(`tooltip-${id}`)

      elemToRemove.parentNode.removeChild(elemToRemove)
    } catch (e) {

    }
  }
}

export default {
  bind (el, bindings, vNode) {
    const id = vNode.context['_uid']

    el.enterFn = enterFn(el, bindings, id)
    el.leaveFn = leaveFn(id)

    el.addEventListener('mouseenter', el.enterFn)
    el.addEventListener('mouseleave', el.leaveFn)
    el.addEventListener('click', el.leaveFn)
  },
  update (el, bindings, vNode) {
    el.removeEventListener('mouseenter', el.enterFn)
    el.removeEventListener('mouseleave', el.leaveFn)
    el.removeEventListener('click', el.leaveFn)

    const id = vNode.context['_uid']

    el.enterFn = enterFn(el, bindings, id)
    el.leaveFn = leaveFn(id)

    el.leaveFn()

    el.addEventListener('mouseenter', el.enterFn)
    el.addEventListener('mouseleave', el.leaveFn)
  }
}
